import { Flex, Tag , Typography } from "antd";
import { useIntl } from "react-intl";

import { PrioritySeverityLevel } from "../enums/PrioritySeverityLevel";
import { getPrimaryColor, getSecondaryColor, getMessageKey } from "../helpers/severity-level";

interface IProps {
    value: number;
    prioritySeverityLevel: PrioritySeverityLevel | null;
}

export const PrioritySeverityPreview = ({ value, prioritySeverityLevel }: IProps) => {
  const intl = useIntl();
  const primaryColor = getPrimaryColor(prioritySeverityLevel);
  const secondaryColor = getSecondaryColor(prioritySeverityLevel);
  const messageKey = getMessageKey(prioritySeverityLevel);

  return (
      <Tag color={secondaryColor} style={{ border: `1px solid ${primaryColor}` }}>
        <Flex align="center" justify="center" style={{ width: "5rem", height: "2rem" }}>
        {messageKey === null ? <Typography.Title level={5}>—</Typography.Title> :
          (<>
          <Typography.Title  style={{ color: primaryColor }} level={5}>{value}</Typography.Title>
            &nbsp;
            <Typography.Text style={{ color: primaryColor, textTransform: 'uppercase', fontSize: 'smaller' }}>
              {intl.formatMessage({ id: `risksAndIssues.severity.${messageKey}` })}
            </Typography.Text>
          </>
          )}
        </Flex>
      </Tag>
  );
};